export { default as i18n } from "./i18n";
export { default } from "./BookingSearcherFormContainer";

import { SearchCriteria as TSearchCriteria } from "./types";
export type SearchCriteria = TSearchCriteria;
